


import IFormDefinition from '../../interfaces/IFormDefinition'
import IFormType from '../../interfaces/IFormType';

export const requestFormDefinition = "REQUEST_FETCH_FORM_DEFINITION";
const successFetchFormDefinition = "SUCCESS_FETCH_FORM_DEFINITION";
const failureFetchFormDefinition = "FAILURE_FETCH_FORM_DEFINITION";

export const requestFormTypes = "REQUEST_FETCH_FORM_TYPES";
const successFetchFormTypes = "SUCCESS_FETCH_FORM_TYPES";
const failureFetchFormTypes = "FAILURE_FETCH_FORM_TYPES";
const appendToFormTypeList = "APPEND_TO_FORM_TYPE_LIST";


// FETCH FORM CONFIG
export interface IRequestFetchFormDefinition {
    type: typeof requestFormDefinition;
    payload: { formId: number }
}

interface ISuccessFetchFormDefinition {
    type: typeof successFetchFormDefinition;
    payload: { formDefinition: IFormDefinition };
}

interface IFailureFetchFormDefinition {
    type: typeof failureFetchFormDefinition;
    payload: { error: Error };
}


export interface IRequestFetchFormTypes {
    type: typeof requestFormTypes;
}

interface ISuccessFetchFormTypes {
    type: typeof successFetchFormTypes;
    payload: { formTypes: IFormType[] };
}

interface IFailureFetchFormTypes {
    type: typeof failureFetchFormTypes;
    payload: { error: Error };
}

interface IAppendToFormTypeList {
    type: typeof appendToFormTypeList;
    payload: { formTypes: IFormType[] };
}



export type IFormAction
    = IRequestFetchFormDefinition
    | ISuccessFetchFormDefinition
    | IFailureFetchFormDefinition

    | IRequestFetchFormTypes
    | ISuccessFetchFormTypes
    | IFailureFetchFormTypes
    | IAppendToFormTypeList
    ;



export const createRequestFetchFormDefinition = (formId: number): IRequestFetchFormDefinition => ({
    type: requestFormDefinition,
    payload: { formId }
});

export const createSuccessFetchFormDefinition = (formDefinition: IFormDefinition): ISuccessFetchFormDefinition => ({
    type: successFetchFormDefinition,
    payload: { formDefinition },
});

export const createFailureFetchFormDefinition = (error: Error): IFailureFetchFormDefinition => ({
    type: failureFetchFormDefinition,
    payload: { error },
});


export const createRequestFetchFormTypes = (): IRequestFetchFormTypes => ({
    type: requestFormTypes,
});

export const createSuccessFetchFormTypes = (formTypes: IFormType[]): ISuccessFetchFormTypes => ({
    type: successFetchFormTypes,
    payload: { formTypes },
});

export const createFailureFetchFormTypes = (error: Error): IFailureFetchFormTypes => ({
    type: failureFetchFormTypes,
    payload: { error },
});


export const createAppendToFormTypeList = (formTypes: IFormType[]): IAppendToFormTypeList => ({
    type: appendToFormTypeList,
    payload: { formTypes },
});



